<template>
	<div>
		<div class="data38">
			<div class="data38Til">{{list.data.menuTitle}}</div>
			<div class="data38Box">
				<div class="data38BoxFor" v-for="(item,index) in list.data.content" :key="index">
					<div class="data38BoxForImg">
						<img :src="item.icon" />
					</div>
					<div class="data38BoxForName">
						{{item.title}}
					</div>
					<div class="data38BoxForWz">
						<div>{{item.text1}}</div>
						<div>{{item.text2}}</div>
					</div>
					<div class="data38BoxForImgTwo">
						<img :src="item.cover" />
						<div class="data38BoxForImgTwoMb"></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				// list:[
				// 	{
				// 		img:require('@/assets/product/page10/mzk.png'),
				// 		name:'麻醉科',
				// 		cen:'临床插管',
				// 		cenTwo:'(MBC-4/5/6)',
				// 		imgDt:require('@/assets/product/page10/mzkDt.png'),
				// 	},
				// 	{
				// 		img:require('@/assets/product/page10/jzk.png'),
				// 		name:'急诊科',
				// 		cen:'临床插管、检查、取异物',
				// 		cenTwo:'(取异物仅限MBC-5/6)',
				// 		imgDt:require('@/assets/product/page10/jzkDt.png'),
				// 	},
				// 	{
				// 		img:require('@/assets/product/page10/icu.png'),
				// 		name:'ICU',
				// 		cen:'吸引、取异物',
				// 		cenTwo:'(MBC-5/6)',
				// 		imgDt:require('@/assets/product/page10/icuDt.png'),
				// 	},
				// 	{
				// 		img:require('@/assets/product/page10/hxk.png'),
				// 		name:'呼吸科',
				// 		cen:'活检、吸引、取异物',
				// 		cenTwo:'(MBC-5/6）',
				// 		imgDt:require('@/assets/product/page10/hxkDt.png'),
				// 	},
				// ]
			}
		},
		mounted() {

		},
		methods: {

		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.data38 {
		width: 1200px;
		margin: 0 auto;
		padding-bottom: 150px;

		.data38Til {
			font-size: 45px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #000000;
			margin-bottom: 68px;
		}

		.data38Box {
			display: flex;

			.data38BoxFor:not(:last-child) {
				margin-right: 10px;
			}

			.data38BoxFor {
				.data38BoxForImg {
					margin-bottom: 39px;

					img {
						width: 70px;
						height: 70px;
						object-fit: cover;
					}
				}

				.data38BoxForName {
					font-size: 26px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #000000;
					margin-bottom: 32px;
				}

				.data38BoxForWz {
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 300;
					color: #000000;
					margin-bottom: 51px;
				}

				.data38BoxForImgTwo {
					width: 295px;
					height: 600px;
					position: relative;

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
					}

					.data38BoxForImgTwoMb {
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
						background-color: rgba(255, 255, 255, 0.5);
						filter: brightness(120%);
					}
				}
			}
		}
	}

	@media screen and (max-width:1200px) {
		.data38 {
			width: 100% !important;
			margin-bottom: 0px !important;
			padding: 0 30px 30px !important;
			box-sizing: border-box;
			.data38Til{
				font-size: 24px !important;
				margin-bottom: 20px !important;
			}
			.data38Box{
				width: 100%;
				overflow-x: auto;
				.data38BoxFor {
					min-width: 100% !important;
					.data38BoxForImg {
						margin-bottom: 20px !important;
						img {
							width: 35px !important;
							height: 35px !important;
							object-fit: contain !important;
						}
					}
					.data38BoxForName{
						font-size: 18px !important;
						margin-bottom: 20px !important;
					}
					.data38BoxForWz{
						font-size: 14px !important;
						margin-bottom: 20px !important;
					}
					.data38BoxForImgTwo{
						width: 100% !important;
							height: auto !important;
						img{
							height: auto !important;
							object-fit: contain !important;
						}
					}
				}
			}
		}
	}
</style>